import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Promise } from './components/Promise';
import { ServicesGrid } from './components/ServicesGrid';
import { SavingsCalculator } from './components/SavingsCalculator';
import { BuyerRebate } from './components/BuyerRebate';
import { HowItWorks } from './components/HowItWorks';
import { AreasWeServe } from './components/AreasWeServe';
import { AboutTrust } from './components/AboutTrust';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background font-sans text-foreground" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Promise data-id="element-4" />
        <ServicesGrid data-id="element-5" />
        <SavingsCalculator data-id="element-6" />
        <BuyerRebate data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <AreasWeServe data-id="element-9" />
        <AboutTrust data-id="element-10" />
        <Testimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}